import { RouterSelectors } from '@next/core-lib/router-store';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import { Barn, DosatorSetting, SettingModuleState } from '../../models/settings.model';

import { barnAdapter, dosatorSettingAdapter } from '../reducers/settings.reducer';

const { selectAll: selectAllBarns } = barnAdapter.getSelectors();
const { selectAll: selectAllDosatorSettings } = dosatorSettingAdapter.getSelectors();

export const getSettingModuleState = createFeatureSelector<SettingModuleState>('settingModule');

export const getEnergySetting = createSelector(
  getSettingModuleState,
  (state) => state.energySystem,
);
export const getLysineSetting = createSelector(
  getSettingModuleState,
  (state) => state.lysineSystem,
);

export const getBarnState = createSelector(getSettingModuleState, (state) => state.barns);

export const getBarns = createSelector(getBarnState, selectAllBarns);

export const getSelectedBarnId = createSelector(RouterSelectors.getMergedRoute, (state) =>
  !isNaN(parseInt(state.params['barnId'], 10)) ? parseInt(state.params['barnId'], 10) : undefined,
);

export const getSelectedBarn = createSelector(getSettingModuleState, (state) => state.selectedBarn);

export const isDuplicateBarnName = createSelector(
  getBarns,
  getSelectedBarn,
  (barns: Barn[], selectedBarn) => (name: string) =>
    !!barns && barns.findIndex((b) => b.name === name && b.id !== selectedBarn.id) !== -1,
);

export const getSilos = createSelector(getSettingModuleState, (state) => state.silos);

export const getNedapInstallations = createSelector(
  getSettingModuleState,
  (state) => state.nedapInstallations,
);

export const getDiscount = createSelector(getSettingModuleState, (state) => state.discount);

export const getLeeOAuthentication = createSelector(
  getSettingModuleState,
  (state) => state.leeOAuthentication,
);

export const getDosatorSettingState = createSelector(
  getSettingModuleState,
  (state) => state.dosatorSettings,
);

export const getDosatorSettings = createSelector(getDosatorSettingState, selectAllDosatorSettings);

export const getSelectedDosatorSettingId = createSelector(
  RouterSelectors.getMergedRoute,
  (state) =>
    !isNaN(parseInt(state.params['dosatorSettingId'], 10))
      ? parseInt(state.params['dosatorSettingId'], 10)
      : undefined,
);

export const getSelectedDosatorSetting = createSelector(
  getSettingModuleState,
  (state) => state.selectedDosatorSetting,
);

export const isDuplicateDosatorSettingName = createSelector(
  getDosatorSettings,
  getSelectedDosatorSetting,
  (dosatorSettings: DosatorSetting[], selectedDosatorSetting) => (name: string) =>
    !!dosatorSettings &&
    dosatorSettings.findIndex((b) => b.name === name && b.id !== selectedDosatorSetting.id) !== -1,
);
